import { render } from "./AddFerm.vue?vue&type=template&id=674d2a1a&scoped=true&ts=true"
import script from "./AddFerm.vue?vue&type=script&lang=ts"
export * from "./AddFerm.vue?vue&type=script&lang=ts"

import "./AddFerm.vue?vue&type=style&index=0&id=674d2a1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674d2a1a"]])

export default __exports__